import React from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import {colors, Typography, withStyles} from '@material-ui/core'

import ScreenShot from './Screenshot'

const styles = {
    dropzone: {
        display: 'flex',
        padding: '1.5em 0 1.5em 0',
        backgroundColor: colors.grey[200],
        borderRadius: '0.5em',
        cursor: 'pointer'
    },
    disabled: {
        opacity: 0.5,
        cursor: 'default'
    },
    label: {
        pointerEvents: 'none',
        flex: 1,
        color: colors.grey[500],
        textAlign: 'center'
    },
    input: {
        display: 'none'
    }
}

class ImageDropper extends React.Component {
    state = {
        files: []
    }

    captions = {}

    onDragOver = event => {
        if (this.props.disabled) return

        event.preventDefault();
        event.stopPropagation();
        this.dropzone.style.backgroundColor = colors.green[100]
    }

    onDragLeave = event => {
        if (this.props.disabled) return

        event.preventDefault();
        event.stopPropagation();
        this.dropzone.style.backgroundColor = colors.grey[200]
    }

    onDrop = event => {
        if (this.props.disabled) return

        event.preventDefault();
        event.stopPropagation();
        this.dropzone.style.backgroundColor = colors.grey[200]
        this.setState({files: event.dataTransfer.files})
        this.input.files = event.dataTransfer.files
    }

    onValidationChangeDetected = () => {
        const isDisabled = Object.keys(this.captions).find(key => {
            return Object.keys(this.captions[key].formFieldsInputs).find(caption => !this.captions[key].formFieldsInputs[caption].state.isValid)
        }) !== undefined
        if (this.props.hasCaption) this.props.onValidationChangeDetected(!isDisabled)
    }

    renderImageList = () => {
        const {defaultCaption1, defaultCaption2, defaultImg, previewSize, save, multiple, hasCaption, onDelete} = this.props
        const screenShotProps = {
            defaultCaption1,
            defaultCaption2,
            defaultImg,
            previewSize,
            save,
            multiple,
            hasCaption,
            onDelete,
            onValidationChangeDetected: this.onValidationChangeDetected,
            onClick: this.onClick
        }

        if (this.state.files.length < 1 && defaultImg) {
            return <ScreenShot innerRef={ref => this.captions[0] = ref || this.captions[0]} {...screenShotProps} />
        }
        const files = [...this.state.files]

        if (!multiple) files.splice(1)

        return (
            <div>
                {files.map((file, index) => <ScreenShot innerRef={ref => this.captions[!multiple ? 0 : file.name] = ref || this.captions[!multiple ? 0 : file.name]} key={index} file={file} {...screenShotProps} />)}
            </div>
        )
    }

    onChange = event => {
        const fileList = event.target.files
        const files = [...fileList]
        if (!this.props.multiple) files.splice(1)
        this.props.onChange(files)
        this.setState({files})
        this.input.files = event.target.files
    }

    clear = () => {
        this.setState({files: []})
    }

    onClick = () => {
        if (!this.props.disabled) this.input.click()
    }

    render() {
        const {classes: styles, name, label, multiple, disabled, withDropZone} = this.props;

        if (withDropZone && this.state.files.length < 1) {
            return (
                <div>
                    <div ref={ref => this.dropzone = ref} onClick={this.onClick} onDragOver={this.onDragOver}
                        onDragLeave={this.onDragLeave} onDrop={this.onDrop}
                        className={classNames(styles.dropzone, disabled ? styles.disabled : '')}
                    >
                        <Typography variant="subtitle1" color="inherit" className={styles.label}>
                            {label}
                        </Typography>
                        <input onChange={this.onChange} ref={ref => this.input = ref} className={styles.input}
                            id={`${name}-imageDropper`} name={name} type="file" multiple={multiple}
                        />
                    </div>
                    {this.renderImageList()}
                </div>
            )
        }
        return (
            <div>
                <input onChange={this.onChange} ref={ref => this.input = ref} className={styles.input}
                    id={`${name}-imageDropper`} name={name} type="file" multiple={multiple}
                />
                {this.renderImageList()}
            </div>
        )
    }
}

ImageDropper.propTypes = {
    classes: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.element.isRequired,
    multiple: PropTypes.bool,
    hasCaption: PropTypes.bool,
    previewSize: PropTypes.string,
    defaultImg: PropTypes.any,
    save: PropTypes.func,
    onChange: PropTypes.func,
    onValidationChangeDetected: PropTypes.func,
    disabled: PropTypes.bool,
    defaultCaption1: PropTypes.string,
    defaultCaption2: PropTypes.string,
    onDelete: PropTypes.func,
    withDropZone: PropTypes.bool
}

ImageDropper.defaultProps = {
    multiple: false,
    hasCaption: false,
    withDropZone: true
}

export default withStyles(styles)(ImageDropper);
